import { render, staticRenderFns } from "./LicensInfoDialog.vue?vue&type=template&id=2b8298a0&scoped=true"
import script from "./LicensInfoDialog.vue?vue&type=script&lang=js"
export * from "./LicensInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8298a0",
  null
  
)

export default component.exports